<template>
  <div id="app" class="main">
    <LayoutFactory/>
    <Snackbar />
  </div>
</template>

<script>
import Snackbar from '@/components/base/Snackbar.vue'
import LayoutFactory from '@/layouts/LayoutFactory.vue'
export default {
  name: 'App',
  components: {
    LayoutFactory,
    Snackbar,
  },
  data: () => ({
    //
  }),
  created () {
    this.$router.beforeEach((to, from, next) => {
      window.scrollTo(0, 0)
      // this.$Progress.start()
      next()
    })

  },
  computed:{
  },
  head() {
    return {
      title: 'کلاسینو - اولین و بزرگترین آموزشگاه و کلاس آنلاین کنکور و پایه'
    }
  }
}
</script>

<style lang="scss" >
@import "assets/sass/app.scss";
@import "styles/main";
.vs-loading__load__text{
  font-size: 1em !important;
}
$font-family: IRANSansX;
$body-font-family : IRANSansX;
$heading-font-family : IRANSansX;


.v-application {
  [class*='text-'] {
    font-family: $font-family !important;
  }
  font-family: $font-family !important;
}

* {
  letter-spacing: 0!important;
}

.v-application {
  background-color: #fff!important;
}
</style>